import { colors } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const Messaging = ({ themeMode = "light" }) => {
	return (
		<Box>
			<Box marginBottom={4}>
				<Typography
					sx={{
						textTransform: "uppercase",
						fontWeight: "medium",
					}}
					gutterBottom
					color="textSecondary"
					align="center"
				/>
				<Box
					component={Typography}
					fontWeight={700}
					variant="h3"
					gutterBottom
					align="center">
					Setting you up for success.
				</Box>
				<Typography
					variant="h6"
					component="p"
					color="textSecondary"
					align="center">
					Ensuring your team is set up for long-term success sits at the core of
					everything we do.
				</Typography>
			</Box>
			<Grid
				container
				spacing={4}>
				{[
					{
						title:
							"In-depth training for your business development team on how to create territories for sale.",
						subtitle: "",
						icon: (
							<svg
								width={40}
								height={40}
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
					{
						title:
							"Guides, videos, and one-on-one training for your sales team on how to scale growth using maps.",
						subtitle: "",
						icon: (
							<svg
								width={40}
								height={40}
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
					{
						title:
							"Responsive, ongoing technical and mapping support across all of your teams whenever they need it.",
						subtitle: "",
						icon: (
							<svg
								width={40}
								height={40}
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
				].map((item, i) => (
					<Grid
						item
						xs={12}
						md={4}
						key={i}>
						<Box color={item.color[themeMode === "light" ? 500 : 700]}>
							{item.icon}
						</Box>
						<Box
							component={Typography}
							variant="h6"
							gutterBottom
							fontWeight={500}>
							{item.title}
						</Box>
						<Typography color="text.secondary">{item.subtitle}</Typography>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Messaging;
